export enum PasswordInputType {
  password = 'password',
  text = 'text'
}